import { render, staticRenderFns } from "./ListEncuesta.vue?vue&type=template&id=bb909af8&scoped=true"
import script from "./ListEncuesta.vue?vue&type=script&lang=js"
export * from "./ListEncuesta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb909af8",
  null
  
)

export default component.exports